import { Phone, Mail, MapPin, Check } from "lucide-react";
import { COMPANY, PROMISES } from "../../data/site";
import { QuoteForm } from "./QuoteForm";
import { Reveal } from "./Motion";

export const QuoteSection = ({ title = "Votre devis anti-moustique gratuit", zone }) => (
  <section id="devis" className="relative py-24 md:py-32 bg-pine text-cream grain overflow-hidden" data-testid="quote-section">
    <div className="relative z-[2] max-w-[1400px] mx-auto px-5 lg:px-10 grid lg:grid-cols-[1fr_1.1fr] gap-14 items-start">
      <Reveal>
        <p className="eyebrow text-lime">Devis gratuit · Réponse rapide</p>
        <h2 className="h2 mt-5">{title}{zone ? <span className="serif-i text-lime"> à {zone}</span> : null}</h2>
        <p className="lead-text mt-6 text-cream/80 max-w-lg">Remplissez le formulaire ou appelez-nous directement. Nous étudions votre extérieur et vous proposons le traitement adapté.</p>
        <a href={COMPANY.phoneHref} className="group mt-10 block" data-testid="quote-section-phone">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-fern">Appelez-nous</span>
          <span className="mt-2 flex items-center gap-4 font-display text-4xl sm:text-5xl font-extrabold tracking-tight group-hover:text-lime transition-colors"><Phone className="w-8 h-8 text-lime" />{COMPANY.phone}</span>
        </a>
        <div className="mt-8 space-y-3 text-cream/85">
          <a href={`mailto:${COMPANY.email}`} className="flex items-center gap-3 hover:text-lime break-all" data-testid="quote-section-email"><Mail className="w-4 h-4 text-lime shrink-0" />{COMPANY.email}</a>
          <p className="flex items-start gap-3"><MapPin className="w-4 h-4 text-lime mt-1 shrink-0" />{COMPANY.street}, {COMPANY.postalCode} {COMPANY.city}</p>
        </div>
        <ul className="mt-10 grid sm:grid-cols-2 gap-3">
          {PROMISES.map(p => <li key={p} className="flex gap-2.5 text-sm text-cream/90"><Check className="w-4 h-4 text-lime mt-0.5 shrink-0" />{p}</li>)}
        </ul>
      </Reveal>
      <Reveal delay={0.1}><QuoteForm /></Reveal>
    </div>
  </section>
);
